import { render, staticRenderFns } from "./Detail-Purchase-Order.vue?vue&type=template&id=2dfcc528&scoped=true"
import script from "./Detail-Purchase-Order.vue?vue&type=script&lang=js"
export * from "./Detail-Purchase-Order.vue?vue&type=script&lang=js"
import style0 from "./Detail-Purchase-Order.vue?vue&type=style&index=0&id=2dfcc528&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfcc528",
  null
  
)

export default component.exports